import { EFeatureTypes, EUserTypes } from 'enums/EFeatureTypes';
import { useCookieCounter } from 'redux/hooks/common';
import { getCookie } from 'utils/Global';

function useRMLite() {
  useCookieCounter();
  const isRMLite = () => {
    if (parseInt(getCookie('userType'), 10) === EUserTypes.RMLite) {
      return true;
    }
    if (
      parseInt(getCookie('userType'), 10) === EUserTypes.All &&
      getCookie('selectedFeature') === EFeatureTypes.RMLite
    ) {
      return true;
    }
    return false;
  };
  return isRMLite();
}

export default useRMLite;
